export default __webpack_public_path__ + "static/media/classroom.124453e5.svg";